import { getFullGrade, getStudentYear } from "@/utils/studentYear";
import { formatDateTimeLocale, formatFullDateLocale } from "@/utils/date";

export function genApplicationID(grade_level, seat_number) {
    const seatNumber = `${seat_number}`.padStart(3, '0')
    if (grade_level == 5) {
        return `5${seatNumber}`
    } else {
        return `1${seatNumber}`
    }
}

export function getStudentPrefix(studentPrefix) {
    if (studentPrefix == 'เด็กชาย') {
        return 'ด.ช.'
    } else if (studentPrefix == 'เด็กหญิง') {
        return 'ด.ญ.'
    } else {
        return studentPrefix
    }
}

export function removeThaiVowels(text) {
    const thaiVowels = [
        '\u0E31', // ั
        '\u0E34-\u0E3A', // ิ ี ึ ื ุ ู ่ ้ ๊ ๋
        '\u0E47-\u0E4E', // ็ ่ ้ ๊ ๋ ์
        '\u0E3F', // ฿
        //'\u0E40-\u0E45'  // เ แ โ ใ ไ ำ
    ].join('');

    const vowelPattern = new RegExp(`[${thaiVowels}]`, 'g');
    return text?.replaceAll(vowelPattern, '');
}

export function changeSchoolTextSize(text) {
    if (text?.length > 40) {
        return 8
    } else if (text?.length > 34) {
        return 9
    } else {
        return null
    }

}

export function cutString(text, cutString = 'โรงเรียน') {
    return text?.replace(cutString, '')?.trim()
}

export function genApplicationData(student, studentParents, isShowTicket = false) {
    // console.log('student', student)
    // console.log('studentParents', studentParents)
    //const today = formatFullDateLocale(new Date());
    const register_form = student?.register_form;
    const student_detail = student?.student_detail;
    const student_address_detail = student?.student_address_detail;
    const student_other_detail = student?.student_other_detail;
    const student_parent_detail = student?.student_parent_detail;
    const student_father = studentParents?.find((item => item.parent_type == 'FATHER'));
    const student_mother = studentParents?.find((item => item.parent_type == 'MOTHER'));

    const studentPrefix = getStudentPrefix(student_detail?.prefix_id?.text_th ?? '');
    const fatherPrefix = student_father?.prefix_th ? student_father?.prefix_th : student_father?.prefix_id?.text_th;
    const motherPrefix = student_mother?.prefix_th ? student_mother?.prefix_th : student_mother?.prefix_id?.text_th;
    const applicantDate = formatFullDateLocale(Date.parse(student?.applicant_date));
    const birthdayDate = formatFullDateLocale(Date.parse(student_detail?.birthday));

    return {
        isShowTicket: isShowTicket,
        schoolName: 'โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์',
        schoolNameEng: 'โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์',
        documentTitle: `ใบสมัครสอบคัดเลือกเข้าเรียนชั้น${getFullGrade(register_form?.grade_level)}`,
        enrollmentGrade: getStudentYear(register_form?.grade_level),
        registrationStartDate: formatDateTimeLocale(Date.parse(register_form?.opening_date)),
        registrationEndDate: formatDateTimeLocale(Date.parse(register_form?.closing_date)),

        applicationDate: applicantDate.split(' ')[0],
        applicationMonth: applicantDate.split(' ')[1],
        applicationYear: applicantDate.split(' ')[2],
        applicationNumber: genApplicationID(register_form?.grade_level, student?.index_number),

        studentName: studentPrefix + student_detail?.name_th,
        lastName: student_detail?.surname_th,
        studentPhoto: student?.student_img?.data,
        birthDate: birthdayDate.split(' ')[0],
        birthMonth: birthdayDate.split(' ')[1],
        birthYear: birthdayDate.split(' ')[2],
        //age: Number(today.split(' ')[2]) - Number(birthdayDate.split(' ')[2]),
        age: new Date(new Date() - new Date(student_detail?.birthday)).getFullYear() - 1970,
        nationality: student_detail?.nationality?.name_th,
        ethnicity: student_detail?.ethnicity?.name_th,
        religion: student_detail?.religion?.name_th,
        idNumber: student_detail?.national_id?.replaceAll(' ', ''),
        phone: student_detail?.phone_number?.replaceAll(' ', ''),

        houseNumber: student_address_detail?.national_address,
        moo: student_address_detail?.national_moo,
        soi: student_address_detail?.national_soi,
        road: student_address_detail?.national_road,
        tambon: student_address_detail?.national_subdistrict?.name_th,
        amphoe: student_address_detail?.national_district?.name_th,
        province: student_address_detail?.national_province?.name_th,
        postalCode: student_address_detail?.national_postal_code,

        currentGrade: student_other_detail?.former_school_last_student_year_id ?? (register_form?.grade_level - 1),
        currentYear: Number(applicantDate.split(' ')[2]),
        previousSchool: cutString(student_other_detail?.former_school_name),
        previousAmphoe: student_other_detail?.former_school_district?.name_th,
        previousProvince: student_other_detail?.former_school_province?.name_th,

        fatherName: fatherPrefix ? fatherPrefix + student_father?.name_th : student_father?.name_th,
        fatherLastName: student_father?.surname_th,
        fatherOccupation: student_father?.career,
        fatherPosition: student_father?.position,
        fatherPhone: student_father?.phone_number.replaceAll(' ', ''),
        fatherWorkplace: student_father?.work_place,

        motherName: motherPrefix ? motherPrefix + student_mother?.name_th : student_mother?.name_th,
        motherLastName: student_mother?.surname_th,
        motherOccupation: student_mother?.career,
        motherPosition: student_mother?.position,
        motherPhone: student_mother?.phone_number.replaceAll(' ', ''),
        motherWorkplace: student_mother?.work_place,

        parentsStatus: student_parent_detail?.family_status,
        hasSibling: student_parent_detail?.is_siblings_study_together,
        siblingName: student_parent_detail?.siblings_name,
        siblingLastName: student_parent_detail?.siblings_surname,
        siblingGrade: student_parent_detail?.siblings_grade,
        siblingHouse: student_parent_detail?.siblings_house,

        examGrade: getFullGrade(register_form?.grade_level),
        examGradeLevel: getStudentYear(register_form?.grade_level),
        examYear: register_form?.semester_year,
        examRoom: '',
        examNumber: '',
        examDate: formatDateTimeLocale(Date.parse(register_form?.exam_date)),
        examTime: register_form?.exam_start_time_phase1,

        checkDoc1: true,
        checkDoc2: true,
        checkDoc3: true,
        checkDoc4: true,
        checkDoc5: true,
        checkDoc6: true,

        schoolFonSize: changeSchoolTextSize(removeThaiVowels(cutString(student_other_detail?.former_school_name))),
    }
}
